import { APIError } from '../../errors/APIError';
import { useAPIMutation, useAPIQuery } from '../../useAPIProvider';

export const useBundleWeighting = (mspId: string, customerId: string, stockLevelId: string, id: string) => {
  return useAPIQuery(['getBundleWeighting', mspId, customerId, stockLevelId, id], async client => {
    const response = await client.bundleWeighting.getBundleWeighting({
      params: { mspId, customerId, stockLevelId, id }
    });
    if (response.status !== 200) throw APIError.fromResponse(response);

    return response.body;
  });
};

interface CreateBundleWeightingArgs {
  mspId: string;
  customerId: string;
  stockLevelId: string;
  customerBundleId: string;
  weighting: number;
}

export const useCreateBundleWeighting = () => {
  return useAPIMutation(client => {
    return async ({ mspId, customerId, stockLevelId, weighting, customerBundleId }: CreateBundleWeightingArgs) => {
      const response = await client.bundleWeighting.createBundleWeighting({
        body: { customerBundleId, weighting },
        params: {
          mspId,
          customerId,
          stockLevelId
        }
      });

      if (response.status !== 200) throw APIError.fromResponse(response);

      return response.body;
    };
  });
};

interface UpdateBundleWeightingArgs extends CreateBundleWeightingArgs {
  id: string;
}

export const useUpdateBundleWeighting = () => {
  return useAPIMutation((client, query) => {
    return async ({ mspId, customerId, stockLevelId, weighting, customerBundleId, id }: UpdateBundleWeightingArgs) => {
      const response = await client.bundleWeighting.updateBundleWeighting({
        body: { customerBundleId, weighting },
        params: {
          mspId,
          customerId,
          stockLevelId,
          id
        }
      });

      if (response.status !== 200) throw APIError.fromResponse(response);

      await query.invalidateQueries(['getBundleWeighting', mspId, customerId, stockLevelId, id]);
      return response.body;
    };
  });
};

interface DeleteBundleWeightingArgs {
  mspId: string;
  customerId: string;
  stockLevelId: string;
  id: string;
}

export const useDeleteBundleWeighting = () => {
  return useAPIMutation(client => {
    return async ({ mspId, customerId, stockLevelId, id }: DeleteBundleWeightingArgs) => {
      return await client.bundleWeighting.deleteBundleWeighting({ params: { mspId, customerId, stockLevelId, id } });
    };
  });
};
